import { Pipe, PipeTransform } from '@angular/core';
import { createAppendButtonId } from '@common/utils';

@Pipe({
  name: 'appendButtonsId',
  pure: true
})
export class GetAppendButtonsIdPipe implements PipeTransform {
  transform(value: string): string {
    return createAppendButtonId(value);
  }
}
